import { LoadableAfterPaint } from '@confluence/loadable';

export { CompanyHubSettingsPageTabsType } from '../src/hub-settings/CompanyHubSettingsPageTabsType.ts';
export const CompanyHubSettingsPage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkCompanyHubSettingsPage" */ '../src/hub-settings/CompanyHubSettingsPage.tsx'
			)
		).CompanyHubSettingsPage,
	name: 'CompanyHubSettingsPage',
});
